export default {
  AuthMethods: {
    QUESTIONS: "QUIZ_CHALLENGE",
    FACIALRECOGNITION: "FACIAL_RECOGNITION",
    UNIQUESTATEPASSWORD: "CUE",
    ECERTADVANCEDSIGN: "E_CERT_VALIDATION"
  },
  QUESTIONS: {
    internalName: "questions",
    title: "Preguntas de Seguridad",
    description:
      "Para validar identidad con esta opción, deberás contestar algunas preguntas. Esta actividad toma alrededor de tres minutos."
  },
  FACIALRECOGNITION: {
    internalName: "facialRecognition",
    title: "Biometría Facial",
    description:
      "Para validar identidad con biometría facial, tu celular debe contar con cámara para poder escanear tu cédula de Identidad."
  },
  UNIQUESTATEPASSWORD: {
    internalName: "uniqueStatePassword",
    title: "Clave Única",
    description: "Para validar identidad con Clave Única, debes tenerla activa a través del Registro Civil."
  },
  ECERTADVANCEDSIGN: {
    internalName: "ecertAdvancedSign",
    title: "Cédula de Identidad + Clave Única",
    description: "Para validar identidad con esta opción, deberás ingresar tu clave única, tener el n° de documento y responder preguntas de seguridad."
  }
};
